import React, { forwardRef, PropsWithChildren, useImperativeHandle, useRef } from 'react';
import styles from './container.module.scss';
import clsx from 'clsx';
interface Props {
    className?: string;
    zIndex?: string | number;
}
export const Container = forwardRef<{ getContentHeight: () => number }, PropsWithChildren<Props>>(({
    children,
    className,
    zIndex = 'unset',
}, ref) => {
    const rootRef = useRef<HTMLDivElement>(null)
    
    // Expose custom methods to parent via ref
    useImperativeHandle(ref, () => {
        return {
            getContentHeight: () =>
                rootRef.current?.getBoundingClientRect().height ?? 0
        }
    });

    return (
        <div
            ref={rootRef}
            style={{ zIndex: zIndex }}
            className={
                clsx(
                    styles.container,
                    className
                )
            }>{children}</div>
    )
});
